import React from "react";
import { Link } from "react-router-dom";

const LatestUpdateSection = () => {
  return (
    <section className="relative w-full h-64 md:h-auto md:aspect-[21/9] overflow-hidden mb-16 md:mb-20">
      {/* Main Banner Container */}
      <div className="relative w-full h-full overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('/images/Bella/Product Photos/sensorAI.PNG')`,
          }}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50" />

        {/* Content */}
        <div className="relative z-10 h-full flex items-center justify-center md:justify-start">
          <div className="text-center md:text-left text-white px-4 md:px-12 max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-script mb-6">
              Check out our latest Update
            </h2>
            <Link
              to="/products"
              className="inline-block bg-white text-brand-blue hover:bg-brand-blue hover:text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 shadow-lg"
            >
              Explore Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestUpdateSection;
